import loadable from '@utils/loadable';

import SentimentTags from '../../SentimentTags';

import Styles from './styles.module.scss';

const SentimentMiniChart = loadable(() => import('../../SentimentMiniChart'));

const ActiveTopicSection = (props) => {
  const { topic, activePeriod } = props;

  return (
    <div className={Styles['active-topic-class']}>
      <div>
        <SentimentMiniChart
          isSingleLine
          isTopic
          isTopicClass
          title={topic.title}
          topic={topic}
          slugType="AssetClass"
          inView
          activePeriod={activePeriod}
        />
      </div>
      <div className={Styles['active-topic-class-tags']}>
        <SentimentTags
          isAssetClass
          entityId={topic.id}
          activePeriod={activePeriod}
        />
      </div>
    </div>
  );
};

export default ActiveTopicSection;
